export default __webpack_public_path__ + "static/media/mined_leads_portal.6408f358.png";